module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main"
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content"
  }, [_c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a04bc1b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/layout/AppMain.vue
// module id = 648
// module chunks = 25